import React from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CapabilityKey } from "@/utils/accessControl";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { useAccessCapabilities } from "@/hooks/useAccessCapabilities";
import { getDefaultAuthorizedRoute } from "@/utils/defaultAuthorizedRoute";

interface CapabilityGuardProps {
  capability: CapabilityKey;
  children: React.ReactNode;
  fallbackPath?: string;
}

export const CapabilityGuard: React.FC<CapabilityGuardProps> = ({
  capability,
  children,
  fallbackPath,
}) => {
  const { t } = useTranslation();
  const { capabilities } = useAccessCapabilities();
  const { isLoading, userProfile } = useAuthenticatedUser();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-muted-foreground">{t("common.loading")}</div>
      </div>
    );
  }

  if (!capabilities[capability]) {
    return (
      <Navigate
        replace
        to={fallbackPath ?? getDefaultAuthorizedRoute(userProfile)}
      />
    );
  }

  return <>{children}</>;
};
